export default __webpack_public_path__ + "static/media/login.885bbbbd.jpg";